import { OrganizationMeta } from '@/entities/onboarding';
import {
  createAuthorizedGetRequest,
  createAuthorizedPostRequest,
  createAuthorizedPutRequest,
  decode,
  encodePaginatableQuery,
  fetchApi,
  PaginatableQuery,
  setBody,
  setQuery,
} from '@/services/api';
import {
  featuredTemplatesResponseCodec,
  organizationMetaResponseCodec,
} from '@/services/api/resources/onboarding/codec';
import { pipe } from 'fp-ts/lib/function';
import { chain, map } from 'fp-ts/TaskEither';

const baseUrl = (id: number) => `/v2/organizations/${id}`;
const recordUrl = (id: number): string => `${baseUrl(id)}/meta`;
const onboardingFinishedUrl = (id: number): string => `${baseUrl(id)}/onboarding-finished`;
const onboardingViewedUrl = (id: number): string => `${baseUrl(id)}/onboarding-viewed`;

const featuredTemplatesUrl = '/v2/onboarding/templates/featured';

export const update = (id: number, params: OrganizationMeta) => pipe(
  id,
  recordUrl,
  createAuthorizedPutRequest,
  map(setBody(params)),
  chain(fetchApi),
);

export const get = (id: number) => pipe(
  id,
  recordUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(organizationMetaResponseCodec)),
);

export const updateOnboardingFinished = (id: number) => pipe(
  id,
  onboardingFinishedUrl,
  createAuthorizedPostRequest,
  chain(fetchApi),
);

export const updateOnboardingViewed = (id: number) => pipe(
  id,
  onboardingViewedUrl,
  createAuthorizedPostRequest,
  chain(fetchApi),
);

export const listFeaturedTemplates = (query: PaginatableQuery) => pipe(
  featuredTemplatesUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodePaginatableQuery(query))),
  chain(fetchApi),
  chain(decode(featuredTemplatesResponseCodec)),
);
